import React, { useEffect, useMemo, useState } from "react";
import EmailInput from "../../../mui/EmailInput";
import CusInput from "../../../mui/custom_input/CusInput";
import InputPhone from "../Input-phone/InputPhone";
import { ENUM_LOGIN } from "../../../../store/enums";
import { useAppSelector } from "../../../../store/index.ts";
import IconLoginUser from "../../../mui/JSXIcons/IconLoginUser.jsx";
import "./email-phone.scss";

const ENUM_TYPE = {
  email: "email",
  phone: "phone"
};

export default function EmailPhone({ typeLogin }) {
  const phoneRegEnabled = useAppSelector((state) => state.common.phoneRegEnabled);
  const emailRegEnabled = useAppSelector((state) => state.common.emailRegEnabled);

  const isRegister = typeLogin == ENUM_LOGIN.register;
  const isPhone = !isRegister || (isRegister && phoneRegEnabled);
  const isMail = !isRegister || (isRegister && emailRegEnabled);
  const defaultInputType = useMemo(() => {
    if (isPhone && isMail) return null;
    if (isMail) return ENUM_TYPE.email;
    if (isPhone) return ENUM_TYPE.phone;
    return null;
  }, [isPhone, isMail]);
  const placeholder =
    phoneRegEnabled && emailRegEnabled ? "Email or Phone" : phoneRegEnabled ? "Phone" : "Email";

  const [inputType, setInputType] = useState(defaultInputType);
  const [value, setValue] = useState("");

  useEffect(() => {
    if ((inputType == ENUM_TYPE.email && !isMail) || (inputType == ENUM_TYPE.phone && isPhone)) {
      setInputType(defaultInputType);
    }

    if (!value) {
      setInputType(defaultInputType);
      return;
    }

    if (isMail && value.includes("@")) {
      setInputType(ENUM_TYPE.email);
      return;
    }

    if (isPhone) {
      if (/^\+?\d+$/.test(value)) {
        setInputType(ENUM_TYPE.phone);
        return;
      }
    }

    if (value == "+") {
      setInputType(ENUM_TYPE.phone);
      return;
    }

    if (isMail) {
      setInputType(ENUM_TYPE.email);
    }

    return;
  }, [value, defaultInputType]);

  const onValueChange = (e) => setValue(e.target.value);

  if (!isMail && !isPhone) return <></>;

  if (inputType == ENUM_TYPE.email)
    return <EmailInput autoFocus value={value} onChange={onValueChange} name="email" />;

  if (inputType == ENUM_TYPE.phone)
    return <InputPhone autoFocus value={value} onChange={onValueChange} name="phone" />;

  return (
    <CusInput
      iconJSXstart={<IconLoginUser className="icon-email-phone" />}
      autoFocus
      placeholder={placeholder}
      value={value}
      onChange={onValueChange}
    />
  );
}
